"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const formatSampleValue = (value, limit = 2000) => {
    let stringValue = value;
    if (Array.isArray(value)) {
        stringValue = value
            .map(thing => (lodash_1.isString(thing) ? thing : JSON.stringify(thing)))
            .join(', ');
    }
    else if (lodash_1.isBoolean(value)) {
        stringValue = String(value);
    }
    return lodash_1.truncate(lodash_1.toString(stringValue), { length: limit });
};
exports.default = formatSampleValue;
